import request from './request';

export async function index(params) {
    return await request('get', `/apiv2/followers`, params);
}

export async function follow(id) {
    return await request('post', `/apiv2/followers/${id}/follow`);
}

export async function unfollow(id) {
    return await request('post', `/apiv2/followers/${id}/unfollow`);
}

export async function acceptFollower(id) {
    return await request('post', `/apiv2/followers/${id}/accept`);
}

export async function rejectFollower(id) {
    return await request('post', `/apiv2/followers/${id}/reject`);
}
